import { commonFilter } from './filter';

export default {
  pageName: 'keyword',
  pageId: '20017',
  pagePath: '/opinion/Stats/Keyword',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
